<template>
    <div>
        <h6 v-if="profileId == 0" class="heading-small text-muted mb-4 text-truncate">
            <!-- Add New User Access Restriction {{ inputName ? " - " + this.inputName : "" }} -->
            Add New User Access Restriction
        </h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">
            <!-- View User Access Restriction - {{ this.inputName }} -->
            View User Access Restriction
        </h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">
            <!-- Edit User Access Restriction - {{ this.inputName }} -->
            Edit User Access Restriction
        </h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{ inputCreatedBy }} | {{ inputCreatedAt | dateFilter }}
                <br />
                <b><label>Updated By:</label></b>
                {{ inputUpdatedBy }} | {{ inputUpdatedAt | dateFilter }}
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <!-- {{bagger}} -->
            <div v-if="customFormMode == 1" v-show="showDetails">
                <base-input label="User" required>
                    <a-select v-model="inputUser" placeholder="Search username" show-search @search="handleUserSearch" :filter-option="false" :not-found-content="fetching ? undefined : null" :disabled="this.$attrs.viewMode">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="user in users" :key="user.id" :value="user.id">
                        {{ user.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Access Start Time" required>
                    <a-time-picker v-model="inputAccessStart" format="HH:mm" :minuteStep=15 class="w-100" />
                </base-input>
                <base-input label="Access End Time" required>
                    <a-time-picker v-model="inputAccessEnd" format="HH:mm" :minuteStep=15 class="w-100" />
                </base-input>
                <base-input label="Effectivity Start Date">
                    <a-date-picker v-model="inputEffectivityStart" allowClear />
                </base-input>
                <base-input label="Effectivity End Date">
                    <a-date-picker v-model="inputEffectivityEnd" allowClear />
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups }" :formSettings="company"
                    @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>
            <div v-if="customFormMode == 3">
                <base-input label="User" required>
                    <a-select v-model="inputUser" placeholder="Search username" show-search @search="handleUserSearch" :filter-option="false" :not-found-content="fetching ? undefined : null" :disabled="this.$attrs.viewMode">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="user in users" :key="user.id" :value="user.id">
                        {{ user.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Access Start Time" required>
                    <a-time-picker v-model="inputAccessStart" format="HH:mm" :minuteStep=15 class="w-100" />
                </base-input>
                <base-input label="Access End Time" required>
                    <a-time-picker v-model="inputAccessEnd" format="HH:mm" :minuteStep=15 class="w-100" />
                </base-input>
                <base-input label="Effectivity Start Date">
                    <a-date-picker v-model="inputEffectivityStart" allowClear />
                </base-input>
                <base-input label="Effectivity End Date">
                    <a-date-picker v-model="inputEffectivityEnd" allowClear />
                </base-input>
            </div>

            <div class="mt-5" v-if="this.$attrs.viewMode != true">
                <!-- Button  -->
                <div v-if="serverType == 'ho'"
                    style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="profileId == 0" type="button" class="btn btn-primary float-right" @click.prevent="create">
                        Create
                    </button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">
                        Update
                    </button>
                </div>
                <div v-else
                    style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">
                        Close
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import DynamicForm from "../DynamicForm.vue";
import ValidateField from "../../components/validateFormUtils.js";
import { mapState } from "vuex";
import secureStorage from '../../controllers/secureStorage.js';
import moment from "moment";

var component_x;
export default {
    components: {
        DynamicForm,
    },
    computed: {
        ...mapState(["endPoint", "profileId", "serverType"]),
    },
    mounted: async function () {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(
            this.endPoint + "system_modules/User%20Access%20Restriction?field_name=name",
            null
        );
        const sytemModuleId = sytemModule.id;
        const accSystemModuleRequest = await HTTPRequest.getRequest(
            this.endPoint +
            "account_system_modules/" +
            sytemModuleId +
            "?field_name=system_module_id",
            null
        );
        if (this.isJsonString(accSystemModuleRequest.meta) == true) {
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
            if (accSystemModule != null) {
                if (accSystemModule.form_mode != undefined) {
                    this.customFormMode = accSystemModule.form_mode;
                }
                if (accSystemModule.customized_forms != undefined) {
                    this.customForm = accSystemModule.customized_forms;
                }
            }
        }

        if (this.$attrs.viewMode == true) {
            var form = document.getElementById("form-proper");
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this;
        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(
                component_x.endPoint + "user_access_restrictions/" + component_x.profileId,
                null
            );
            if (data == undefined) {
                component_x.$router.go();
            } else {
                if (data["error"] == undefined) {
                    let user_data = await HTTPRequest.getRequest(this.endPoint + "users/" + data["user_id"], null)
                    this.users.push({
                        id: user_data.id,
                        name: user_data.user_name
                    })

                    component_x.inputUser = data["user_id"]
                    // component_x.inputAccessStart = data["access_start"]
                    // component_x.inputAccessEnd = data["access_end"]
                    component_x.inputAccessStart = moment(data["access_start"])
                    component_x.inputAccessEnd = moment(data["access_end"])
                    if (data["effectivity_start"])
                        component_x.inputEffectivityStart = moment(data["effectivity_start"])
                    if (data["effectivity_end"])
                        component_x.inputEffectivityEnd = moment(data["effectivity_end"])
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                } else {
                    this.errors = data["error"].split(","); //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
        this.dynamicFormKey++;
    },
    data: function () {
        this.handleUserSearch = _.debounce(this.handleUserSearch, 800)
        return {
            inputUser: null,
            inputAccessStart: null,
            inputAccessEnd: null,
            inputEffectivityStart: null,
            inputEffectivityEnd: null,
            inputCreatedBy: null,
            inputCreatedAt: null,
            inputUpdatedBy: null,
            inputUpdatedAt: null,
            showDetails: true,
            errors: [],
            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            company: {},
            formErrors: [],
            fetching: false,
            lastFetchId: 0,
            users: []
        };
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format("L LTS");
        },
    },
    methods: {
        handleUserSearch (value) {
            this.fetching = true
            this.lastFetchId += 1;
            const fetchId = this.lastFetchId;

            fetch(this.endPoint + `users?user_name=${value}`, {
                headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
                "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
                }
            }).then(res => res.json())
            .then(res => {
                if (fetchId !== this.lastFetchId) {
                // for fetch callback order
                return;
                }
                this.users = res.data.map(value => {
                    return {
                        id: value.id,
                        name: value.user_name
                    }
                })
                this.fetching = false
            })
        },
        updateSettings (newFormSettings, settingsGrouping, errors) {
            var formSettingsCopy = this.company;
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors;

            if (this.customFormMode == 3) {
                this.errors = errors;
            }

            this.company = mergedHash;
        },
        isJsonString (str) {
            try {
                var json = JSON.parse(str);
                return typeof json === "object";
            } catch (e) {
                return false;
            }
        },
        openDetails () {
            this.showDetails = true;
        },
        openHistory () {
            this.showDetails = false;
        },
        validateForm () {
            this.errors = [];
            this.errors.push(ValidateField.required("User", this.inputUser));
            this.errors.push(ValidateField.required("Access Start Time", this.inputAccessStart))
            this.errors.push(ValidateField.required("Access Start End", this.inputAccessEnd))
            this.errors.push(ValidateField.identicalField("Access Start Time", "Access End Time", this.inputAccessStart, this.inputAccessEnd))
            if (this.inputEffectivityStart && this.inputEffectivityEnd)
                this.errors.push(ValidateField.isGreaterThan("Effectivity Date", this.inputEffectivityStart, this.inputEffectivityEnd, "Effectivity Start Date should be before Effectivity End Date"))

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName(
                "ant-drawer-wrapper-body"
            )[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            if (!this.validateForm()) {
                var payload = {
                    user_access_restriction: {
                        user_id: this.inputUser,
                        access_start: this.inputAccessStart,
                        access_end: this.inputAccessEnd,
                        effectivity_start: this.inputEffectivityStart,
                        effectivity_end: this.inputEffectivityEnd
                    },
                };
                var post_request = await HTTPRequest.postRequest(
                    this.endPoint + "user_access_restrictions",
                    null,
                    payload
                );
                if (post_request == undefined) {
                    this.$emit("refreshPage", event);
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit("refreshPage", event);
                    } else {
                        this.errors = post_request["error"].split(","); //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                var payload = {
                    user_access_restriction: {
                        user_id: this.inputUser,
                        access_start: this.inputAccessStart,
                        access_end: this.inputAccessEnd,
                        effectivity_start: this.inputEffectivityStart,
                        effectivity_end: this.inputEffectivityEnd
                    },
                };
                var put_request = await HTTPRequest.putRequest(
                    this.endPoint + "user_access_restrictions/" + this.profileId,
                    null,
                    payload
                );
                if (put_request == undefined) {
                    this.$emit("refreshPage", event);
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit("refreshPage", event);
                    } else {
                        this.errors = put_request["error"].split(","); //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
    },
};
</script>

<style>

</style>